module.exports = __webpack_public_path__ + "static/media/event-1.d932c5e4.jpg";